import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../hoc/Loading/Loading';
import axios from '../../axios';
import {groupContentFields, groupPrivacyStatusDesc, grpBannerImg, profilePicValidityCheck} from '../../utils/constants';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import * as url from '../../utils/url';
import CreateGroupMenu from './Components/CreateGroupMenu'
import GrpBannerImgModal from './Components/GrpBannerModal.jsx'


class CreateGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {  
      name:'',
      privacy:null,
      description:'',
      memberCount:1,
      bannerImg:null,
      isBannerOpen:false,
      welcomeMessage:""
    }
  }

componentDidMount() {
  console.log(this.props)
}


createMarkup = (input) => {
  return { __html: `<div>${input}</div>` };
}
 
renderContent = () => {
    let {searchedPhrase, help, searchedTerm} = this.state
    if(searchedTerm!==""){
        return <div dangerouslySetInnerHTML={this.createMarkup(searchedPhrase)}/>
    }else {
        return <div dangerouslySetInnerHTML={this.createMarkup(help)}/>
    }
}

changeGroupName=(name)=>{
  // console.log('value: ', value)
  // let obj = {...this.state, ...value}
  // console.log(obj)
  this.setState({name})
}

changePrivacy=privacy=>{
  // console.log('create---- ', privacy)
  if(privacy){
    let id = typeof(privacy)=='object'?privacy.id: privacy
    this.setState({privacy:id})
  }
 
}

handleInvitedUsers = mLength =>{
  this.setState({memberCount:mLength+1})
}


getInitials=(user)=>{
  let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
  let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
  return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
}

changeGrpBannerImg=query=>{
  // headers: {
  //   'Authorization': `Basic ${token}` 
  // }
}

openBannerModal=()=>{
  this.setState( prevState => ({
    isBannerOpen: !prevState.isBannerOpen
  }))
    
}

setBannerImg = image =>{
  this.setState({bannerImg:image})
}

handleGrpDesc = value =>{
  // console.log('handleGrpDesc----', value)
  this.setState({description:value})
}
handleGrpWelcomeMessage = value =>{
  // console.log('handleGrpDesc----', value)
  this.setState({welcomeMessage:value})
}

handleGrpWelcomeMessage = value =>{
  // console.log('handleGrpDesc----', value)
  this.setState({welcomeMessage:value})
}

removeBannerImg=()=>{
  this.setState({bannerImg:null})
}

render() {
    let {
      name,
      privacy,
      description,
      invitedUsers,
      memberCount,
      bannerImg
    }=this.state


    let privacy_status=null
    if(privacy){
      privacy_status = (privacy=='ENTERPRISE'?'Open':privacy=="PRIVATE"?"Private":privacy)
    }

    let user_name = `${this.props.user.profile.firstName} ${this.props.user.profile.lastName}`
    let profilePic = this.props.user.profile && profilePicValidityCheck(this.props.user.profile.profilePic)?this.props.user.profile.profilePic: false
  return (<span>
      <CreateGroupMenu 
      bannerImg={bannerImg}
      handleGrpWelcomeMessage={this.handleGrpWelcomeMessage}
      handleGrpDesc={this.handleGrpDesc}
      handleGrpWelcomeMessage={this.handleGrpWelcomeMessage}
      handleInvitedUsers={this.handleInvitedUsers}
      changePrivacy={this.changePrivacy}
      changeGroupName={this.changeGroupName}/>
      <div className="grp_create_page_container boxShadow1 create_page_group_start_init">
          <div className="grp_create_page_bannerImg_container" onClick={()=>this.openBannerModal()}>
            <span className="grp_create_page_bannerImg_txt"> Change image </span>
                <img src={bannerImg!=null&&bannerImg.url?bannerImg.url:grpBannerImg} 
                className={`grp_create_page_bannerImg ${bannerImg==null?'banner_filter':'boxShadow1'}`}
                />
          </div>
        
          <div className="grp_create_page_details">
              <span className={`grp_create_page_group_name ${name!=''?'active':''}`}>{name!=''?name:'Group Name'}</span>
              <span className="grp_create_page_group_status"> {privacy!=null?groupContentFields(privacy)['name']:"Group Status"}</span> · <span className="grp_create_page_member_count">{memberCount} members</span>
          </div>


          <div className="grp_create_page_details_2">
            <span className="grp_page_menu_items">About</span>
            <span className="grp_page_menu_items">Posts</span>
            <span className="grp_page_menu_items">Planning</span>
            <span className="grp_page_menu_items">Analytics</span>
            <span className="grp_page_menu_items">Resources</span>
            <span className="grp_page_menu_items">Events</span>
            <span className="grp_page_menu_items">Members</span>
          </div>


          <div className="grp_create_page_details_3">
                        <div className="rounded-lg shadow grp_create_page_post_container">
                            <div className="flex justify-between">
                              {profilePic!=false?
                               <img src={profilePic} alt="MD. Shibbir Ahmed"/>
                              :
                               <span data-letters={this.getInitials(this.props.user.profile)}></span>
                              }
                               
                                <input className="flex-1 px-4 outline-none" placeholder={`What's on your mind, ${user_name}`}/>
                            </div>
                           
              </div>
         
              <div className="grp_create_page_privacy_status_info">
               
                <span className="grp_create_page_privacy_status_details title">
                  About
                </span>
                <span className="grp_create_page_privacy_status_details description">
                  {description}
                </span>
                {privacy?
                  <span className="grp_create_page_privacy_status_details option">
                    {groupContentFields(privacy).name}
                    <span> {groupContentFields(privacy).description} </span>
                    <span> {groupContentFields(privacy).permission} </span>
                  </span>
                :
                  <span>
                    {groupPrivacyStatusDesc.map(e=>{
                      return(
                        <span className="grp_create_page_privacy_status_details option" key={e.id}>
                         {e.name}
                         <span> {e.description} </span>
                       </span>)
                    })}
                    {/* <span className="grp_create_page_privacy_status_details option">
                      Private
                      <span> Group and all related content is visible only to invited member </span>
                    </span>
                    <span className="grp_create_page_privacy_status_details option">
                      Open
                      <span> Group and all related content is visible to anyone and anyone can join. </span>
                    </span> */}
                  </span>
                }

              </div>         
         
          </div>
         




      </div>


        <GrpBannerImgModal
        removeBannerImg={this.removeBannerImg} 
        setBannerImg={this.setBannerImg}
        image = {this.state.bannerImg}
        openBannerModal={this.openBannerModal}
        isBannerOpen={this.state.isBannerOpen}/>

      </span>
    );
  }
}










const mapStateToProps = state => {
    return {
      user: state.user,
      kpiMaster: state.kpiMaster,
      mappingMaster: state.mappingMaster,
      reports:state.reports
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
      onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
      onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
      updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
      updateReport: (dashboard)=> dispatch(actionCreators.updateReport(dashboard)),
  
    }
  }


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(CreateGroup, axios)));